import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SmallNavbar from './components/smallNavbar';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Services from './pages/Services/Services';
import Contact from './pages/Contact';
import './index.css';
import ScrollToTop from './components/ScrollToTopButton';
import ScrollToTopOnRouteChange from './components/ScrollToTopOnRouteChange';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsapp';
import WhatsAppPopup from './components/WhatsAppPopup';
import Privacy from './pages/privacy';
import Terms from './pages/terms';
import Cookies from './pages/cookies';

function App() {
  return (
    <Router>
      <ScrollToTopOnRouteChange />
      <div className="overflow-x-hidden">
        {/* Small top navbar - auto-hides on scroll */}
        <SmallNavbar />
        
        {/* Main navigation navbar - auto-hides on scroll, positioned below SmallNavbar */}
        <Navbar />
        
        {/* Main content with proper top padding to account for both navbars */}
        {/* SmallNavbar: ~32px (py-1.5 = 6px top + 6px bottom + content height ~20px) */}
        {/* MainNavbar: ~56px (h-14 = 56px) */}
        {/* Total: ~88px, using pt-24 (96px) for safe spacing */}
        <main className="mobile-nav-bottom pt-24">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />
          </Routes>
        </main>
        <FloatingWhatsApp />
        
        {/* WhatsApp Marketing Popup - Mobile Only */}
        <WhatsAppPopup />
        
        {/* Footer */}
        <Footer />
        
        {/* Scroll to top button */}
        <ScrollToTop />
      </div>
    </Router>
  );
}

export default App;